// File: client/src/variants/zombie/rulebook.js
// Canonical rulebook for Zombie Chess.

const rulebook = {
  overview:
    'Death is not the end. Every piece you capture rises three turns later as a zombie under YOUR control. Grow a shambling horde and overwhelm the board.',
  objective:
    'Checkmate the opponent’s king, as in classic chess. Zombies are extra muscle — they can’t be your king, but they can swarm and capture.',
  setup:
    'Standard starting position on a full 8×8 board. White moves first. No zombies at the start.',
  turnFlow: [
    'Make one normal legal move (your own pieces or any zombies you control).',
    'If your move captures an enemy piece, that piece is marked to rise as YOUR zombie in 3 of your turns.',
    'At the start-of-count each of your turns, any of your pending zombies whose timer reaches zero spawn on the board.',
  ],
  mechanics: [
    {
      title: 'Infection',
      body: 'When you capture an enemy piece, it does not simply die — it is queued to return as a zombie you control after 3 of your turns. Kings are the exception: capturing a king ends the game (and kings never become zombies).',
    },
    {
      title: 'Zombie pieces',
      items: [
        'Move one square in any direction (like a king).',
        'Can capture — and a piece a zombie captures also becomes a zombie for the zombie’s controller (the infection spreads).',
        'Cannot promote and cannot castle.',
        'Worth no material — they are disposable horde units.',
        'A zombie gives check only from an adjacent square (its true range).',
      ],
    },
    {
      title: 'Where zombies rise',
      body: 'A zombie returns on the square where its piece was captured if that square is empty; otherwise it appears on the nearest empty square. If no nearby square is free, that revival is lost.',
    },
  ],
  winConditions: [
    'Win by checkmating the opponent’s king (zombies count toward delivering mate).',
    'Win if the opponent resigns or runs out of time.',
    'Stalemate is a draw.',
  ],
  tips: [
    'Trading pieces is good for you — you get the captured piece back as a zombie.',
    'Zombies are slow (one square) but relentless; use them to blockade and swarm.',
    'Protect your king: a wall of zombies makes a fine bodyguard.',
  ],
  knownInteractions: [
    'Rule decision: a revived piece returns as a generic ZOMBIE (king-move, worth 0), not as its original type. This keeps the infection theme and avoids re-spawning powerful pieces like queens.',
    'Rule decision: zombies belong to the CAPTURER (infection), not their original owner.',
    'Rule decision: the 3-turn timer counts the CAPTURER’s own turns, so a zombie rises on your 3rd turn after the capture.',
    'Rule decision: if there is no empty square near the capture point when a zombie is due, that revival is dropped (rare, only on a very crowded board).',
    'Engine note: zombies are a registered custom piece, so check, checkmate and stalemate detection correctly treat them as adjacent-only attackers.',
    'AI: the computer plays standard chess and moves zombies it controls, but does not specifically strategise around the infection timeline. Documented limitation.',
  ],
};

export default rulebook;
